import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AdminAuthProvider, useAdminAuth } from './context/Adminauthcontext';
import { NotificationProvider } from './context/NotificationContext';
import Sidebar from './components/layout/Sidebar';
import AdminLoginPage    from './pages/AdminLoginPage';
import DashboardPage     from './pages/DashboardPage';
import AppointmentsPage  from './pages/AppointmentsPage';
import ServiceTrackerPage from './pages/ServiceTrackerPage';
import MechanicsPage     from './pages/MechanicsPage';
import CarHistoryPage    from './pages/CarHistoryPage';
import BillingPage       from './pages/BillingPage';
import ServicesManagePage from './pages/ServicesManagePage';
import CataloguePage     from './pages/CataloguePage';
import InventoryPage     from './pages/InventoryPage';
import SettingsPage      from './pages/SettingsPage';
import './components/layout/Sidebar.css';

function AdminRoutes() {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'var(--bg-primary)', color:'var(--text-muted)', fontFamily:'var(--font-body)', fontSize:14, flexDirection:'column', gap:12 }}>
        <div style={{ width:32, height:32, borderRadius:'50%', border:'3px solid var(--border)', borderTopColor:'var(--accent)', animation:'spin 0.7s linear infinite' }} />
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        Loading AutoElite Admin...
      </div>
    );
  }

  // Not authenticated — show full-screen login
  if (!admin) return <AdminLoginPage />;

  // Authenticated — show dashboard layout
  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-main">
        <Routes>
          <Route path="/"             element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard"    element={<DashboardPage />} />
          <Route path="/appointments" element={<AppointmentsPage />} />
          <Route path="/service"          element={<ServiceTrackerPage />} />
          <Route path="/mechanics"         element={<MechanicsPage />} />
          <Route path="/services-manage"   element={<ServicesManagePage />} />
          <Route path="/catalogue"         element={<CataloguePage />} />
          <Route path="/history"           element={<CarHistoryPage />} />
          <Route path="/billing"      element={<BillingPage />} />
          <Route path="/inventory"    element={<InventoryPage />} />
          <Route path="/settings"     element={<SettingsPage />} />
          <Route path="*"             element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AdminAuthProvider>
          <NotificationProvider>
            <AdminRoutes />
          </NotificationProvider>
        </AdminAuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}